import React, { useEffect, useState } from "react";
import api from "../../services/axiosInstance";
import { 
  FaUserPlus, FaTimes, FaUser, FaEnvelope, 
  FaLock, FaMagic, FaMapMarkerAlt, FaPhone,
  FaArrowLeft, FaCheckCircle
} from "react-icons/fa";
import loginBoy from './signup.jpg';

const RegisterModal = ({ isOpen, onClose, onSwitchToLogin }) => {
  const [currentStep, setCurrentStep] = useState("form"); // "form" or "otp"
  const [otp, setOtp] = useState("");
  const [resendTimer, setResendTimer] = useState(6);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    wilaya: "",
    number: "",
    password: "",
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
useEffect(() => {
  if (currentStep !== "otp") return;

  if (resendTimer === 0) return;

  const interval = setInterval(() => {
    setResendTimer((prev) => prev - 1);
  }, 1000);

  return () => clearInterval(interval);
}, [currentStep, resendTimer]);

  if (!isOpen) return null;

const handleResendOtp = async () => {
  setLoading(true);
  setMessage("");

  try {
    const res = await api.post("/users/resend-otp", {
      email: formData.email,
    });
    setMessage(res.data.message);
    setResendTimer(60);
  } catch (err) {
    setMessage(err.response?.data?.message || "Erreur.");
  } finally {
    setLoading(false);
  }
};

  const handleChange = (e) => {
    setFormData({ 
      ...formData, 
      [e.target.name]: e.target.value 
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      const res = await api.post("/users/send-otp", formData);
      setMessage(res.data.message);
      setCurrentStep("otp");
    } catch (err) {
      setMessage(err.response?.data?.message || "Erreur d'envoi du code.");
    } finally {
      setResendTimer(6);
      setLoading(false);
    }
  }; 

  const handleOtpVerification = async () => {
    setLoading(true);
    setMessage("");

    try {
      const res = await api.post("/users/verify-otp", { 
        email: formData.email, 
        otp 
      });
      setMessage(res.data.message);
      setTimeout(() => {
        onClose();
        onSwitchToLogin();
      }, 2000);
    } catch (err) {
      setMessage(err.response?.data?.message || "Code invalide.");
    } finally {
      setLoading(false);
    }
  };

  const handleBackToForm = () => {
    setCurrentStep("form");
    setOtp("");
    setMessage("");
  };

  return (
  <div onClick={onClose}
   className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-gray-900/40 backdrop-blur-sm">
  <div onClick={(e) => e.stopPropagation()}  className="w-full max-w-5xl max-h-[90vh] lg:max-h-[85vh] overflow-hidden bg-white rounded-2xl shadow-2xl flex flex-col lg:flex-row">
    
    {/* Left Side - Register Form */}
    <div className="w-full lg:w-1/2 p-6 md:p-8 lg:p-10 overflow-y-auto">
      {/* Header - Clean and minimal */}
      <div className="">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="p-2 rounded-lg bg-emerald-50">
              <FaUserPlus className="text-lg text-emerald-600" />
            </div>
            <div>
              <h2 className="text-xl md:text-2xl font-bold text-gray-900">
                {currentStep === "form" ? "Créer un compte" : "Vérification"}
              </h2>
              <p className="text-sm md:text-base text-gray-600 mt-1">
                {currentStep === "form" 
                  ? "Rejoignez notre communauté dès aujourd'hui" 
                  : `Code envoyé à ${formData.email}`}
              </p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="p-2 text-gray-400 transition-colors rounded-lg hover:text-gray-700 hover:bg-gray-100"
            aria-label="Fermer"
          >
            <FaTimes className="text-xl" />
          </button>
        </div>
      </div>

      {/* Body - Clean form layout */}
      <div className="pt-4 md:pt-6">
        {currentStep === "form" ? (
          <form className="space-y-4" onSubmit={handleSubmit}>
            {/* Name Field */}
            <div>
              <div className="relative">
                <FaUser className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" />
                <input
                  name="name"
                  type="text"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Votre nom complet"
                  required
                  className="w-full pl-12 pr-4 py-3 md:py-4 text-gray-900 placeholder-gray-500 bg-gray-50 border border-gray-200 rounded-3xl focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500 focus:outline-none transition-all duration-200 focus:bg-white text-sm md:text-base"
                />
              </div>
            </div>

            {/* Email Field */}
            <div>
              <div className="relative">
                <FaEnvelope className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" />
                <input
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="votre@email.com"
                  required
                  className="w-full pl-12 pr-4 py-3 md:py-4 text-gray-900 placeholder-gray-500 bg-gray-50 border border-gray-200 rounded-3xl focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500 focus:outline-none transition-all duration-200 focus:bg-white text-sm md:text-base"
                />
              </div>
            </div>

            {/* Wilaya Field */}
            <div>
              <div className="relative">
                <FaMapMarkerAlt className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" />
                <input
                  name="wilaya"
                  type="text"
                  value={formData.wilaya}
                  onChange={handleChange}
                  placeholder="Ex: Alger"
                  required
                  className="w-full pl-12 pr-4 py-3 md:py-4 text-gray-900 placeholder-gray-500 bg-gray-50 border border-gray-200 rounded-3xl focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500 focus:outline-none transition-all duration-200 focus:bg-white text-sm md:text-base"
                />
              </div>
            </div>

            {/* Phone Field */}
            <div>
              <div className="relative">
                <FaPhone className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" />
                <input
                  name="number"
                  type="text"
                  value={formData.number}
                  onChange={handleChange}
                  placeholder="Ex: 0555123456"
                  className="w-full pl-12 pr-4 py-3 md:py-4 text-gray-900 placeholder-gray-500 bg-gray-50 border border-gray-200 rounded-3xl focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500 focus:outline-none transition-all duration-200 focus:bg-white text-sm md:text-base"
                />
              </div>
            </div>

            {/* Password Field */}
            <div>
              <div className="relative">
                <FaLock className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" />
                <input
                  name="password"
                  type="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="Minimum 8 caractères"
                  required
                  className="w-full pl-12 pr-4 py-3 md:py-4 text-gray-900 placeholder-gray-500 bg-gray-50 border border-gray-200 rounded-3xl focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500 focus:outline-none transition-all duration-200 focus:bg-white text-sm md:text-base"
                />
              </div>
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              disabled={loading}
              className="w-full px-4 py-3 md:py-4 text-white font-semibold bg-emerald-500 hover:bg-emerald-600 active:scale-[0.98] disabled:opacity-50 disabled:cursor-not-allowed rounded-3xl transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2 shadow-md hover:shadow-lg text-sm md:text-base"
            >
              {loading ? (
                <span className="flex items-center justify-center">
                  <svg className="w-5 h-5 mr-2 animate-spin" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                  </svg>
                  Envoi du code...
                </span>
              ) : (
                <span className="flex items-center justify-center">
                  <FaMagic className="mr-2 md:mr-3" />
                  Continuer
                </span>
              )}
            </button>
          </form>
        ) : (
          /* OTP Verification Step */
          <div className="space-y-6">
            <div className="text-center">
              <div className="w-12 h-12 md:w-16 md:h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <FaEnvelope className="text-xl md:text-2xl text-emerald-600" />
              </div>
              <h3 className="text-lg md:text-xl font-bold text-gray-800 mb-2">
                Vérification par email
              </h3>
              <p className="text-sm md:text-base text-gray-600">
                Nous avons envoyé un code à 6 chiffres à<br />
                <span className="font-semibold text-emerald-600">{formData.email}</span>
              </p>
            </div>

            <div className="space-y-4">
              <div className="text-center">
                <label className="text-sm font-medium text-gray-700 mb-3 block">
                  Code de vérification
                </label>
                <input
                  type="text"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))}
                  maxLength="6"
                  className="w-full border border-gray-200 rounded-3xl py-3 md:py-4 px-4 text-center text-xl md:text-2xl font-bold tracking-widest focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500 focus:outline-none transition-all duration-200 bg-gray-50"
                  placeholder="000000"
                  autoFocus
                />
                <p className="text-xs text-gray-500 mt-2">
                  Saisissez les 6 chiffres reçus par email
                </p>
              </div>
              
              <div className="text-center mt-4">
                {resendTimer > 0 ? (
                  <p className="text-sm text-gray-500">
                    Renvoyer le code dans <span className="font-semibold">{resendTimer}s</span>
                  </p>
                ) : (
                  <button
                    onClick={handleResendOtp}
                    disabled={loading}
                    className="text-sm font-semibold text-emerald-600 hover:text-emerald-700 transition"
                  >
                    Renvoyer le code
                  </button>
                )}
              </div>

              {/* Back Button for OTP */}
              <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
                <button
                  onClick={handleBackToForm}
                  className="flex-1 px-4 py-3 text-emerald-600 font-medium bg-emerald-50 border border-emerald-200 hover:bg-emerald-100 active:scale-[0.98] rounded-3xl transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2 text-sm md:text-base"
                >
                  <span className="flex items-center justify-center">
                    <FaArrowLeft className="mr-2" />
                    Modifier l'email
                  </span>
                </button>
                
                <button
                  onClick={handleOtpVerification}
                  disabled={loading || otp.length !== 6}
                  className="flex-1 px-4 py-3 md:py-4 text-white font-semibold bg-emerald-500 hover:bg-emerald-600 active:scale-[0.98] disabled:opacity-50 disabled:cursor-not-allowed rounded-3xl transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2 shadow-md hover:shadow-lg text-sm md:text-base"
                >
                  {loading ? (
                    <span className="flex items-center justify-center">
                      <svg className="w-5 h-5 mr-2 animate-spin" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                      </svg>
                      Vérification...
                    </span>
                  ) : (
                    <span className="flex items-center justify-center">
                      <FaCheckCircle className="mr-2" />
                      Vérifier et créer
                    </span>
                  )}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Messages */}
        {message && (
          <div className={`mt-4 md:mt-6 px-4 py-3 text-sm rounded-xl border ${
            message.startsWith("✅") || message.includes("succès")
              ? "bg-emerald-50 text-emerald-700 border-emerald-100"
              : "bg-red-50 text-red-700 border-red-100"
          }`}>
            {message}
          </div>
        )}

        {/* Footer - Only show on form step */}
        {currentStep === "form" && (
          <div className="text-center mt-4 md:mt-6">
            <button
              onClick={() => {
                onClose();
                onSwitchToLogin();
              }}
              className="text-sm font-medium text-gray-700 hover:text-emerald-600 transition-colors focus:outline-none focus:underline px-4 py-2 rounded-lg hover:bg-gray-50"
            >
              Connectez-vous ici
            </button>
          </div>
        )}
      </div>
    </div>

    {/* Right Side - Image Illustration - Hidden on mobile/tablet, visible on lg+ */}
    <div className="hidden lg:block w-1/2 relative overflow-hidden">
      {/* Full cover background image */}
      <div className="absolute inset-0">
        <img
          src={loginBoy} 
          alt="Illustration" 
          className="w-full h-full object-cover"
        />
        {/* Dark gradient overlay for better readability */}
        <div className="absolute inset-0 bg-gradient-to-t from-emerald-700/50 via-emerald-700/40 to-emerald-700/40"></div>
      </div>
      
      {/* Content container - positioned over the image */}
      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center p-12 text-center">
        <div className="w-full max-w-md space-y-8">
          
          {/* Text content */}
          <div className="space-y-6">
            <div>
              <h3 className="text-4xl font-bold text-white mb-4 leading-tight">
                Rejoignez notre communauté
              </h3>
              <p className="text-xl text-gray-300 font-medium">
                Créez votre compte pour commencer votre parcours
              </p>
            </div>

            {/* Quote/Testimonial */}
            <div className="pt-12 mt-8 border-t border-gray-300/30">
              <p className="text-gray-200 italic text-lg font-medium">
                "La meilleure plateforme pour education"
              </p>
            </div>
          </div>
        </div>
      </div>
      
      {/* Decorative elements */}
      <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-emerald-400 to-transparent"></div>
      <div className="absolute top-10 right-10 w-32 h-32 bg-emerald-500/10 rounded-full blur-2xl"></div>
      <div className="absolute bottom-10 left-10 w-40 h-40 bg-emerald-600/10 rounded-full blur-2xl"></div>
      
      {/* Optional: Add a subtle vignette effect */}
      <div className="absolute inset-0 shadow-[inset_0_0_100px_rgba(0,0,0,0.5)]"></div>
    </div>
  </div>
</div> 
  );
};

export default RegisterModal;